// extracted by mini-css-extract-plugin
export default {"button":"Jw7r74","hiddenLabel":"fqYBhr"};